import { motion } from "framer-motion";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  const footerSections = [
    {
      title: "Platform",
      links: ["About", "Features", "Blog", "Careers"],
    },
    {
      title: "Community",
      links: ["Join", "Events", "Forum", "Discord"],
    },
    {
      title: "Legal",
      links: ["Privacy", "Terms", "Cookies", "Disclaimer"],
    },
    {
      title: "Connect",
      links: ["Telegram", "Twitter", "Email", "Support"],
    },
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.08,
        delayChildren: 0.1,
      },
    },
  };

  const sectionVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, ease: [0.4, 0, 0.2, 1] },
    },
  };

  const linkVariants = {
    hidden: { opacity: 0, x: -10 },
    visible: {
      opacity: 1,
      x: 0,
      transition: { duration: 0.5 },
    },
    hover: {
      x: 4,
      transition: { duration: 0.2 },
    },
  };

  const bottomVariants = {
    hidden: { opacity: 0, y: 10 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, delay: 0.3 },
    },
  };
  return (
    <footer className="border-t border-border">
      <div className="max-w-7xl mx-auto px-4 py-16 sm:px-6 lg:px-8">
        {/* Main Footer Content */}
        <motion.div
          className="grid grid-cols-2 md:grid-cols-4 gap-12 mb-12"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
        >
          {footerSections.map((section, sectionIdx) => (
            <motion.div
              key={sectionIdx}
              variants={sectionVariants}
            >
              <motion.h4
                initial={{ opacity: 0, y: -10 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{
                  delay: sectionIdx * 0.08 + 0.1,
                  duration: 0.5,
                }}
                className="text-xs font-medium text-foreground uppercase tracking-widest mb-6"
              >
                {section.title}
              </motion.h4>
              <motion.ul
                className="space-y-3"
                variants={containerVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
              >
                {section.links.map((link, linkIdx) => (
                  <motion.li
                    key={linkIdx}
                    variants={linkVariants}
                  >
                    <motion.a
                      href="#"
                      className="text-sm text-muted-foreground hover:text-foreground transition-colors inline-block"
                      whileHover="hover"
                      variants={linkVariants}
                    >
                      {link}
                    </motion.a>
                  </motion.li>
                ))}
              </motion.ul>
            </motion.div>
          ))}
        </motion.div>

        {/* Divider */}
        <motion.div
          initial={{ scaleX: 0 }}
          whileInView={{ scaleX: 1 }}
          transition={{ duration: 0.8, delay: 0.3 }}
          origin="left"
          className="border-t border-border mb-8"
        />

        {/* Bottom Section */}
        <motion.div
          variants={bottomVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          className="flex flex-col md:flex-row items-center justify-between gap-4"
        >
          <motion.p
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.4, duration: 0.6 }}
            className="text-xs text-muted-foreground"
          >
            © {currentYear} MuskConnect Pro. All rights reserved.
          </motion.p>
          <motion.p
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.4, duration: 0.6 }}
            className="text-xs text-muted-foreground/60 text-center max-w-lg"
          >
            Disclaimer: Educational platform. Not affiliated with Elon Musk or his companies.
            Investments carry risk. Consult a financial advisor.
          </motion.p>
        </motion.div>
      </div>
    </footer>
  );
}